import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Link from 'redux-first-router-link'

import { goToAdventure, goToHome } from '../redux/actions/routing/route.actions'

import STAGES from '../constants/STAGES'

import DefaultFrame from '../components/frame/DefaultFrame'
import getBattleResult from '../redux/selectors/getBattleResult'
import AdviceBox from '../components/other/AdviceBox'
import Rewards from '../components/other/RewardBox'

const BattleResult = (props) => {
    const {
        battleStage, result,
    } = props

    const stageData = STAGES[battleStage]
    const rewards = stageData.reward[result]

    const resultHeader = () => {
        switch (result) {
            case 'first': {
                return {
                    headerText: 'Stage cleared, congratulation!',
                    headerClass: 'result__header result__header--won',
                }
            }
            case 'repeat': {
                return {
                    headerText: 'Stage cleared again, great!',
                    headerClass: 'result__header result__header--repeat',
                }
            }
            case 'lost':
            default: {
                return {
                    headerText: 'YOU DIED',
                    headerClass: 'result__header result__header--lost',
                }
            }
        }
    }
    const { headerText, headerClass } = resultHeader()

    return (
        <DefaultFrame>
            <div className="scene--base scene__battle-result">
                <div className="scene--title">
                    <h1 className={headerClass}>
                        {headerText}
                    </h1>
                </div>

                <Rewards rewards={rewards} />

                { (result === 'lost') && <AdviceBox category={result} /> }

                <Link className="buttonLink--wrapper" to={goToAdventure()}>
                    <button className="button--base" type="button">Back to Adventure</button>
                </Link>
                <Link className="buttonLink--wrapper" to={goToHome()}>
                    <button className="button--base" type="button">Back to Home</button>
                </Link>
            </div>
        </DefaultFrame>
    )
}

BattleResult.propTypes = {
    battleStage: PropTypes.string.isRequired,
    result: PropTypes.string.isRequired,
}

const mapStateToProps = state => ({
    battleStage: state.battleStage,
    result: getBattleResult(state),
})

export default connect(
    mapStateToProps,
)(BattleResult)
